
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { ProjectState } from "../../../shared";
import { resizeLayers, roundEven } from "../helpers/project";
import FilmStrip from "./FilmStrip";
import VideoTracks from "./VideoTracks";

type Props = {
    project: ProjectState
}

function Timeline({ project: _project }: Props) {
    const canvasDimensions = useSelector((state: RootState) => state.canvas.dimensions);
    const project = {
        ..._project,
        dimensions: {
          ..._project.dimensions
        },
        layers: [
            ..._project.layers
        ]
    };
    const height = roundEven(window.innerHeight - canvasDimensions.height);
    const width = roundEven(height * project.dimensions.width / project.dimensions.height);
    project.layers = resizeLayers(project, width, height);
    project.dimensions.width = width;
    project.dimensions.height = height;

    console.log('rerender Timeline')

    return (
        <div
            style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '100%',
                height: project.dimensions.height,
                backgroundColor: 'gray',
                borderTop: '1px solid gray'
            }}>
            {project.type === 'timelapse' ? (
                <FilmStrip project={project} />
            ) : project.type === 'video' && (
                <VideoTracks project={project} />
            )}
        </div>
    );
}

export default Timeline;